(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Fudge-products-slider"] && !Shopify.designMode) return;
  try {
    
  function initFudgeSlider() {
    const swiperContainer = document.querySelector(".fudge-slider .swiper");
    if (!swiperContainer) return;
    
    // Check if Swiper is already initialized on this container
    if (swiperContainer.swiper) {
      swiperContainer.swiper.destroy(true, true);
    }
    
    // Wait for Swiper library to be available
    if (typeof Swiper === 'undefined') {
      setTimeout(initFudgeSlider, 100);
      return;
    }
    
    // Wait for slides to be rendered
    const slides = swiperContainer.querySelectorAll('.swiper-slide');
    if (slides.length === 0) {
      setTimeout(initFudgeSlider, 100);
      return;
    }
    
    // Initialize Swiper (noSwipingClass so taps on product cards fire click, not swipe)
    const swiper = new Swiper(swiperContainer, {
      slidesPerView: 4,
      spaceBetween: 20,
      loop: slides.length > 4,
      observer: true,
      observeParents: true,
      watchOverflow: true,
      noSwipingClass: "productitem",
      noSwiping: false,
      navigation: {
        nextEl: ".fudge-slider .swiper-button-next",
        prevEl: ".fudge-slider .swiper-button-prev"
      },
      pagination: {
        el: ".fudge-slider .swiper-pagination",
        clickable: true
      },
      breakpoints: {
        320: {
          slidesPerView: 2,
          spaceBetween: 10
        },
        680: {
          slidesPerView: 3
        },
        1024: {
          slidesPerView: 4
        }
      },
      on: {
        init: function() {
          // Force update after initialization
          this.update();
          this.updateSlides();
        }
      }
    });
    
    // Force update after a short delay to ensure everything is rendered
    setTimeout(function() {
      if (swiper) {
        swiper.update();
        swiper.updateSlides();
      }
    }, 200);
  }
  
  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener("DOMContentLoaded", initFudgeSlider);
  } else {
    initFudgeSlider();
  }
  
  // Also initialize on window load to ensure images are loaded
  window.addEventListener("load", function() {
    setTimeout(initFudgeSlider, 100);
  });

  } catch(e) { console.error(e); }
})();
})();
